import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cf692604"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "item"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line-left"
  }, null, -1);
});

var _hoisted_3 = {
  class: "switch"
};
var _hoisted_4 = {
  key: 0,
  class: "none"
};
var _hoisted_5 = {
  key: 0,
  class: "name"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "btn-name"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "male"
};
var _hoisted_10 = {
  class: "text"
};
var _hoisted_11 = {
  key: 0,
  class: "model-l"
};
var _hoisted_12 = {
  key: 1
};
var _hoisted_13 = {
  class: "btn-name"
};
var _hoisted_14 = {
  key: 2
};
var _hoisted_15 = {
  key: 3
};
var _hoisted_16 = {
  key: 4
};
var _hoisted_17 = ["onClick"];
var _hoisted_18 = {
  key: 0,
  class: "name"
};
var _hoisted_19 = {
  class: "btn-name"
};
var _hoisted_20 = {
  key: 1,
  class: "name"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  class: "text"
};
var _hoisted_23 = {
  key: 0,
  class: "model-l"
};
var _hoisted_24 = {
  key: 1
};
var _hoisted_25 = {
  class: "btn-name"
};
var _hoisted_26 = {
  key: 5,
  class: "name"
};
var _hoisted_27 = ["onClick"];
var _hoisted_28 = {
  class: "children"
};
var _hoisted_29 = {
  key: 0,
  class: "more-child"
};
var _hoisted_30 = {
  class: "male"
};
var _hoisted_31 = ["onClick"];
var _hoisted_32 = {
  key: 1,
  class: "more-child more-brother"
};
var _hoisted_33 = ["onClick"];
import { watch, ref, nextTick } from 'vue';
import MyTree from '../myTree';
export default {
  props: {
    list: {
      // 接收父组件传值,并设置默认值
      type: Array,
      default: function _default() {
        return [];
      }
    },
    input: {
      type: Object,
      default: null
    }
  },
  emits: ['triggerMenu', 'addNewNode', 'onTextChange', 'submit', 'changeExpand', 'deletePedigreeDetail'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var inputS = ref();
    var listDetail = ref([]);

    var triggerMenu = function triggerMenu(item) {
      emits('triggerMenu', item);
    };

    var addNewNode = function addNewNode(type, id) {
      emits('addNewNode', type, id);
    };

    var onTextChange = function onTextChange(item) {
      emits('onTextChange', item);
    };

    var submit = function submit(item) {
      emits('submit', item);
    };

    var removeNode = function removeNode(index) {
      listDetail.value.splice(index, 1);
    };

    var removeSpouse = function removeSpouse(index, indexS) {
      listDetail.value[index].spouseList.splice(indexS, 1);
    };

    var deletePedigreeDetail = function deletePedigreeDetail() {
      emits('deletePedigreeDetail');
    };

    watch(function () {
      return props.list;
    }, function () {
      listDetail.value = props.list;
    }, {
      deep: true,
      immediate: true
    });
    watch(function () {
      return props.input;
    }, function () {
      if (props.input != null && props.input.writing) {
        inputS.value = props.input;
        nextTick(function () {
          if (inputS.value != null && inputS.value.focus != null) {
            inputS.value.focus();
          }
        });
      }
    }, {
      deep: true,
      immediate: true
    });

    var changeExpand = function changeExpand(item) {
      emits('changeExpand', item);
    };

    return function (_ctx, _cache) {
      var _component_remove = _resolveComponent("remove");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_circle_plus = _resolveComponent("circle-plus");

      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_Delete = _resolveComponent("Delete");

      var _component_el_input = _resolveComponent("el-input");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["node", [{
            expand: item.expand
          }, {
            'last-item': item.lastItem
          }]])
        }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [!item.hasbranch ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : item.expand ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          onClick: function onClick($event) {
            return changeExpand(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_remove)];
          }),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          onClick: function onClick($event) {
            return changeExpand(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_circle_plus)];
          }),
          _: 2
        }, 1032, ["onClick"]))]), item.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
          class: _normalizeClass(item.sex == 0 ? 'male' : 'female')
        }, [_createVNode(_component_svg_icon, {
          icon: item.sex == 0 ? 'male' : 'female'
        }, null, 8, ["icon"])], 2), _createElementVNode("div", {
          class: _normalizeClass([{
            selected: item.selected
          }, "text"]),
          onClick: function onClick($event) {
            return triggerMenu(item);
          }
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.surname), 1), _createElementVNode("span", null, _toDisplayString(item.name), 1)])], 10, _hoisted_6), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_icon, {
          class: "deleteIcon",
          onClick: deletePedigreeDetail
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_Delete)];
          }),
          _: 1
        })], 512), [[_vShow, item.selected]])])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["name", item.writing ? 'writing' : 'undone']),
          onClick: function onClick($event) {
            return triggerMenu(item);
          }
        }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_svg_icon, {
          icon: "male"
        })]), _createElementVNode("div", _hoisted_10, [item.writing ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_input, {
          ref_for: true,
          ref_key: "inputS",
          ref: inputS,
          type: "text",
          size: "small",
          placeholder: "请输入",
          style: {
            "width": "70px"
          },
          onBlur: function onBlur($event) {
            return onTextChange(item, $event);
          },
          onKeyup: _withKeys(function ($event) {
            return submit(item);
          }, ["enter"]),
          modelValue: item.surname,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.surname = $event;
          }
        }, null, 8, ["onBlur", "onKeyup", "modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("button", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(item.surname), 1), _createElementVNode("span", null, _toDisplayString(item.name), 1)])]))])], 10, _hoisted_8)), item.ranking ? (_openBlock(), _createElementBlock("span", _hoisted_14, "[" + _toDisplayString(item.ranking) + "]", 1)) : _createCommentVNode("", true), item.levelName ? (_openBlock(), _createElementBlock("span", _hoisted_15, "[" + _toDisplayString(item.levelName) + "]", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_icon, {
          class: "icon",
          onClick: function onClick($event) {
            return removeNode(index);
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_Delete)];
          }),
          _: 2
        }, 1032, ["onClick"])])), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.spouseList, function (a, indexS) {
          return _openBlock(), _createElementBlock("div", {
            key: indexS,
            onClick: function onClick($event) {
              return triggerMenu(a);
            }
          }, [a.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", null, [_createVNode(_component_svg_icon, {
            icon: item.sex == 0 ? 'female' : 'male',
            class: _normalizeClass(item.sex == 0 ? 'female' : 'male')
          }, null, 8, ["icon", "class"])]), _createElementVNode("div", {
            class: _normalizeClass(["text", {
              selected: a.selected
            }])
          }, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(a.surname), 1), _createElementVNode("span", null, _toDisplayString(a.name), 1)])], 2), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_icon, {
            class: "deleteIcon",
            onClick: deletePedigreeDetail
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Delete)];
            }),
            _: 1
          })], 512), [[_vShow, a.selected]])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
            class: _normalizeClass(item.sex == 0 ? 'female' : 'male')
          }, [_createVNode(_component_svg_icon, {
            icon: item.sex == 0 ? 'female' : 'male'
          }, null, 8, ["icon"])], 2), _createElementVNode("div", {
            class: _normalizeClass(a.writing ? 'writing' : 'undone'),
            onClick: function onClick($event) {
              return triggerMenu(a);
            }
          }, [_createElementVNode("div", _hoisted_22, [a.writing ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_input, {
            ref_for: true,
            ref_key: "inputS",
            ref: inputS,
            type: "text",
            size: "small",
            placeholder: "请输入",
            style: {
              "width": "70px"
            },
            onBlur: function onBlur($event) {
              return onTextChange(a);
            },
            onKeyup: _withKeys(function ($event) {
              return submit(a);
            }, ["enter"]),
            modelValue: a.surname,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return a.surname = $event;
            }
          }, null, 8, ["onBlur", "onKeyup", "modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", null, _toDisplayString(a.surname), 1), _createElementVNode("span", null, _toDisplayString(a.name), 1)])]))])], 10, _hoisted_21), _createVNode(_component_el_icon, {
            class: "icon",
            onClick: function onClick($event) {
              return removeSpouse(index, indexS);
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Delete)];
            }),
            _: 2
          }, 1032, ["onClick"])]))], 8, _hoisted_17);
        }), 128)), item.selected && !item.writing && item.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_svg_icon, {
          icon: item.sex == 0 ? 'female' : 'male',
          class: _normalizeClass(item.sex == 0 ? 'female' : 'male')
        }, null, 8, ["icon", "class"]), _createElementVNode("div", {
          class: "text more-wife",
          onClick: function onClick($event) {
            return addNewNode(1, item.id);
          }
        }, "+ 添加配偶", 8, _hoisted_27)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_28, [item.expand && item.child != null && item.child && item.child.length > 0 ? (_openBlock(), _createBlock(_unref(MyTree), {
          key: 0,
          list: item.child,
          input: __props.input,
          onTriggerMenu: triggerMenu,
          onAddNewNode: addNewNode,
          onOnTextChange: onTextChange,
          onSubmit: submit,
          onChangeExpand: changeExpand,
          onDeletePedigreeDetail: deletePedigreeDetail
        }, null, 8, ["list", "input"])) : _createCommentVNode("", true)]), item.selected && !item.writing && item.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_svg_icon, {
          icon: "male"
        })]), _createElementVNode("div", {
          class: "text",
          onClick: function onClick($event) {
            return addNewNode(0, item.id);
          }
        }, "+ 添加孩子", 8, _hoisted_31)])) : _createCommentVNode("", true), item.selected && !item.writing && item.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_svg_icon, {
          icon: "male",
          class: "male"
        }), _createElementVNode("div", {
          class: "text",
          onClick: function onClick($event) {
            return addNewNode(2, item.parentId);
          }
        }, "+ 添加兄妹", 8, _hoisted_33)])) : _createCommentVNode("", true)], 2);
      }), 128);
    };
  }
};